// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"account":"2be1cf56","administration":"41dbe5c6"}[chunkId] + ".chunk.js";
};